import './index.css';
import { useEffect } from 'react';
import { Button } from '@mui/material';
import { Header, ScreenBackground, View, Text, RouteWrapper } from '../../../component';
import useTheme from '../../../utilities/hooks/theme';
import { TiDeleteOutline } from 'react-icons/ti';
import { useDispatch } from 'react-redux';
import { showErrorToast } from '../../../actions/app-actions-types';
import I18n from '../../../utilities/locale';

const PaymentFailed = () => {
  const dispatch = useDispatch();
  const { AccountTheme: theme } = useTheme();

  const successTitle = {
    color: theme.paymentFailTitle
  };

  const goBackBtn = {
    backgroundColor: theme.paymentFailGoBack,
    color: theme.paymentFailGoBackTitle
  };

  useEffect(() => {
    dispatch(showErrorToast(I18n.t('TransactionFailed')));
    const timeout = setTimeout(() => {
      onPressBack();
    }, 10);
    return () => {
      clearTimeout(timeout);
    };
  }, []);

  const onPressBack = () => {
    window?.open('about:blank', '_self');
    window?.close();
  };

  return (
    <RouteWrapper>
      <ScreenBackground>
        <Header onClickBack={onPressBack} />
        <View className={'payment-failed-container'}>
          <TiDeleteOutline color={theme.paymentFailedIcon} size={50} />
          <Text style={successTitle} className={'payment-failed-title'}>
            {'Payment Failed'}
          </Text>
          <Button
            onClick={onPressBack}
            style={goBackBtn}
            className={'payment-failed-go-back-button'}>
            {'Go Back'}
          </Button>
        </View>
      </ScreenBackground>
    </RouteWrapper>
  );
};

export default PaymentFailed;
